import React from 'react'
import { Box, Typography, styled } from '@mui/material'
import { MUIThemeColors } from 'src/mui-theme'
import { getThemeColor } from 'src/utils'
import { DrawingColumn } from '../components/positions/configure/ConfigurePositionsDrawing.style'

// The workspace of the Expand grid and Olex upload modes: the preview on the left, the choices and the buttons that
// apply them in a side panel on the right, in the place of the configure drawing and panel.
export const ModeColumn = DrawingColumn

export const ModeCanvas = styled(Box)(({ theme }) => ({
  position: 'relative',
  flex: '1 1 auto',
  minHeight: 360,
  overflow: 'hidden',
  border: `1px solid ${getThemeColor(theme, MUIThemeColors.secondaryLight)}`,
  borderRadius: 8,
  backgroundColor: getThemeColor(theme, MUIThemeColors.backgroundMain),
  [theme.breakpoints.up('md')]: { minHeight: 0 },
}))

// Names what the canvas shows, over its top left corner.
export const ModeTag = styled(Typography)(({ theme }) => ({
  position: 'absolute',
  left: theme.spacing(1.5),
  top: theme.spacing(1.25),
  zIndex: 1,
  padding: theme.spacing(0.5, 1.25),
  fontSize: 12,
  fontWeight: 600,
  color: getThemeColor(theme, MUIThemeColors.successDark),
  backgroundColor: getThemeColor(theme, MUIThemeColors.white),
  border: `1px solid ${getThemeColor(theme, MUIThemeColors.secondaryLight)}`,
  borderRadius: 6,
}))

export const ModeLegend = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexWrap: 'wrap',
  gap: theme.spacing(0.5, 2),
  paddingBottom: theme.spacing(0.5),
  fontSize: 12,
  color: getThemeColor(theme, MUIThemeColors.secondaryDark),
}))

export const ModeAside = styled(Box)(({ theme }) => {
  const line = getThemeColor(theme, MUIThemeColors.secondaryLight)
  return {
    display: 'flex',
    flexDirection: 'column',
    minHeight: 0,
    borderTop: `1px solid ${line}`,
    backgroundColor: getThemeColor(theme, MUIThemeColors.white),
    [theme.breakpoints.up('md')]: { borderTop: 'none', borderLeft: `1px solid ${line}` },
  }
})

export const AsideHead = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(0.5),
  padding: theme.spacing(1.5, 2.5, 1),
}))

export const AsideScroll = styled(Box)(({ theme }) => ({
  flex: 1,
  minHeight: 0,
  overflowY: 'auto',
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(2),
  padding: theme.spacing(0.5, 2.5, 2),
}))

export const AsideActions = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(1),
  padding: theme.spacing(1.5, 2.5, 2),
  borderTop: `1px solid ${getThemeColor(theme, MUIThemeColors.secondaryLight)}`,
}))

export const ActionRow = styled(Box)(({ theme }) => ({ display: 'flex', gap: theme.spacing(1.25) }))

// A legend entry: a colour sample followed by what it means.
export const LegendItem: React.FC<{ color: string; dashed?: boolean; children: React.ReactNode }> = ({
  color,
  dashed,
  children,
}) => (
  <Box component="span" display="inline-flex" alignItems="center" gap={0.75}>
    <Box
      component="span"
      sx={{ width: 14, height: 0, borderTop: `3px ${dashed ? 'dashed' : 'solid'} ${color}`, display: 'inline-block' }}
    />
    {children}
  </Box>
)
